import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Card, Row, CardBody } from "reactstrap";
import { Link, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getFeedbackList, getParentsToStaffFeddbacks } from "store/actions";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Spinners from "components/Common/Spinner";

const TeacherFeedback = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const [searchParams] = useSearchParams();
    const selectedTab = searchParams.get("selected-tab");

    const { feedbacklist, errors, successMsg, Loading } = useSelector(
        state => state.FeedBackReducer
    )

    const [feedbackType, setFeedbackType] = useState("New Threads");
    //New Threads
    //Old Threads

    const [sortedFeedbackList, setSortedFeedbackList] = useState([]);


    const PARENT_ORIGIN = 'https://pmapp.prisms.in/';

    window.addEventListener('message', event => {
        const host = event.origin;
        const parts = host.split('.');
        const rootDomain = parts.slice(-2).join('.');

        console.log(rootDomain);

        // 1️⃣ Security check
        if (rootDomain === PARENT_ORIGIN) return;

        const { action, items } = event.data;
        if (action === 'bulkSet' && typeof items === 'object') {
            // 2️⃣ Loop through and store each item
            Object.entries(items).forEach(([key, value]) => {
                // Ensure everything is a string
                localStorage.setItem(key, String(value));
            });

            // 3️⃣ Send back a simple acknowledgment
            event.source.postMessage(
                { status: 'ok', storedKeys: Object.keys(items) },
                event.origin
            );
        }
    });

    useEffect(() => {
        if (successMsg && successMsg !== null) {
            toast.success(successMsg)
        }
    }, [successMsg])


    useEffect(() => {
        dispatch(getFeedbackList({}))
    }, [])

    useEffect(() => {
        if (selectedTab && selectedTab !== "") {
            setFeedbackType(selectedTab);
        }
    }, [selectedTab])

    const changeTab = (tabName) => {
        const routeName = location.pathname;
        // console.log(routeName)
        navigate(`${routeName}?selected-tab=${tabName}`)
    }

    const redirectToChats = (feedback) => {
        console.log(`Navigating to: ${location.pathname}/chats`);
        navigate(`${location.pathname}/chats`, {
            state: {
                conversationID: feedback.conversation_id,
                chatSubject: feedback.subject,
                from_name: feedback?.from_name || null,
                from_id: feedback?.from_id || null, // for ADMIN to view conversation of parents to teachers
                feedbackType: feedbackType,
                div_name: feedback.div_name,
            },
        });
    };


    const renderDate = (dateNum) => {

        const returnDate = (timestamp) => {

            return moment.utc(timestamp).format("DD/MM/YYYY"); // Ensure no timezone shift
        };

        return returnDate(dateNum);
    };


    useEffect(() => {
        const handlePopState = () => {
            navigate("/dashboard");
        };
        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [navigate]);


    useEffect(() => {
        let newList = [];

        const sortByTimestampDesc = (array) => {
            return array.sort((a, b) => new Date(b.latest_msg_updatedDate) - new Date(a.latest_msg_updatedDate));
        };

        if (feedbackType === "New Threads") {
            for (let i = 0; i < feedbacklist.length; i++) {
                if (feedbacklist[i].new_or_old_status === "New") {
                    newList.push(feedbacklist[i])
                }
            }


        } else if (feedbackType === "Old Threads") {
            for (let i = 0; i < feedbacklist.length; i++) {
                if (feedbacklist[i].new_or_old_status === "Old") {
                    newList.push(feedbacklist[i])
                }
            }
        } else {
            newList = feedbacklist ? feedbacklist : []
        }
        setSortedFeedbackList(sortByTimestampDesc(newList))

    }, [feedbacklist, feedbackType])

    return (
        <div className="page-content">


            <Container className="p-0">

                <div className="d-flex mb-2 mx-0 border border-2 p-1 rounded-3 overflow-auto">

                    <div
                        className={`border border-2 p-2 rounded-5 ${feedbackType === 'New Threads' ? 'bg-primary text-white' : ''}  text-nowrap `}
                        onClick={() => changeTab("New Threads")}
                        style={{ cursor: 'pointer' }}
                    >
                        New
                    </div>

                    <div
                        className={`border border-2 p-2 rounded-5 text-nowrap ${feedbackType === 'Old Threads' ? 'bg-primary text-white' : ''}`}
                        onClick={() => changeTab("Old Threads")}
                        style={{ cursor: 'pointer' }}
                    >
                        Replied
                    </div>

                </div>

                {
                    Loading ? <Spinners /> :
                        <Card className="p-2">
                            <CardBody className="p-1">
                                <div className="">
                                    {sortedFeedbackList && sortedFeedbackList.length > 0 ? (
                                        sortedFeedbackList.map((feedback, index) => (
                                            <div
                                                key={index}
                                                onClick={() => redirectToChats(feedback)}
                                                className="chat-contact-link"
                                            >
                                                <Row className="chat-contact">
                                                    <Col
                                                        xs={12}
                                                        className={`d-flex flex-column justify-content-center ${feedback.read_status === 'Unread' ? 'fw-bold' : ''}`}
                                                    >
                                                        <div className="w-100">
                                                            <div className="d-flex justify-content-between">
                                                                <p
                                                                    style={{ fontSize: "1.1rem" }}
                                                                    className="p-0 m-0 chat-contact-subject"
                                                                >
                                                                    {feedback.subject}
                                                                </p>
                                                                <p className="p-0 m-0 text-secondary chat-contact-date">
                                                                    {renderDate(feedback.createdDate)}
                                                                </p>
                                                            </div>
                                                            <div className="">
                                                                <p className="p-0 m-0 text-secondary chat-contact-to">
                                                                    From: {feedback.from_name} - {feedback.div_name}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))
                                    ) : <p className="text-center m-0">There are no feedback messages present</p>}
                                </div>

                            </CardBody>
                        </Card>
                }
            </Container>

        </div>
    )
}

export default TeacherFeedback